module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/media/super-touch-video-en.13dd7b56.mp4";